<template>
  <div class="support-ticket-info">
    <a class="close-ticket-info" href="#">
      <i class="os-icon os-icon-ui-23"></i>
    </a>
    <div class="customer" v-if="user">
      <div class="avatar"><img alt="" :src="api+'api/v1/users/get/profile_pic/'+user.id"></div>
      <h4 class="customer-name">{{ user.fullName }}</h4>
      <div class="customer-tickets">@{{ user.username }}</div>
    </div>
    <h5 class="info-header">{{ user.balance | toMoney(user.currency) }}</h5>
    <div class="info-section text-center">
      <div class="label">{{ t.total_payments }}:</div>
      <div class="value text-primary">{{ user.payment | toMoney(user.currency) }}</div>
      <div class="label">{{ t.total_withdrawal }}:</div>
      <div class="value text-primary">{{ user.withdraw | toMoney(user.currency) }}</div>
      <div class="label">{{ t.last_withdraw }}:</div>
      <div class="value">
        <div class="badge badge-primary">{{ user.last_withdraw }}</div>
      </div>
      <div class="value" v-if="user.last_money_transfer_at">
        {{ dateTimeFormat(user.last_money_transfer_at) }} <br />
        <span class="text-danger">{{ user.last_money_transfer_at | timeAgo }}</span>
      </div>
      <div class="label">{{ t.user.last_login}}:</div>
      <div class="value" v-if="user.lastLogin">
        {{ dateTimeFormat(user.lastLogin) }} <br />
        <span class="text-danger">{{ user.lastLogin | timeAgo }}</span>
      </div>
      <div class="label">Notes:</div>
        <div class="value" v-if="user.note">
        <textarea class="form-control">{{ user.note }}</textarea>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'supportTicketWidget',
        props: ['id'],
        data () {
            return {
                t: this.$root.t,
                api: window.api,
                user: null
            }
        },
        watch: {
            'id' () {
                this.fetchUser()
            }
        },
        mounted () {
            this.fetchUser()
        },
        methods: {
            fetchUser () {
                if(this.id)
                  this.$http.get(api+'api/v1/users?uid='+this.id)
                      .then(response => {

                          this.user = response.body.result.users[0];
                      }, response => {
                  })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/widget/supportTicketWidget.vue